import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['slice'];

  connect() {
    this.form = this.element.closest('form');
    this.form.addEventListener('input', this.handleFormChange);
  }

  disconnect() {
    this.form.removeEventListener('input', this.handleFormChange);
  }

  handleFormChange = (e) => {
    if (!this.element.contains(e.target)) {
      return;
    }

    const { type, value } = e.target;

    if (type === 'radio') {
      this.element.querySelector('input[type="text"]').value = '';
    } else if (type === 'text' && value) {
      const checkedRadio = this.element.querySelector('input[type="radio"]:checked');

      if (checkedRadio) {
        checkedRadio.checked = false;
      }
    }
  };

  loadMore(e) {
    const toOpen = this.sliceTargets.filter((slice) => slice.hidden);

    if (toOpen[0]) {
      toOpen[0].hidden = false;
    }

    if (!toOpen[1]) {
      e.target.closest('button').parentElement.remove();
    }
  }
}
